export default [
    {
        key: "Alfa numérico",
        value: false
    },
    {
        key: "Número da Ficha",
        value: false
    },
    {
        key: "Nome do produto",
        value: false
    },
    {
        key: "ID do Produto",
        value: false
    },
    {
        key: "Linha",
        value: false
    },
];